require([
    "apps/check-requirements/views/requirement-container-view",
    "apps/check-requirements/models/requirement"
], function (RequirementContainerView, Requirement) {
    'use strict';

    var requirement,
        requirementContainerView;

    requirement = new Requirement();

    requirementContainerView = new RequirementContainerView({
        "el": '.req-info__check-box .results',
        "model": requirement
    });
});

define("apps/check-requirements/main.js", function(){});

